import * as yup from "yup";

import { checkSINValidity } from "../../T4Slip/T4SlipSetup/validator";

// import { currentTaxYear } from "./FilingResourceSetup";

// // import { issuerSelectedValidate } from "./FilingResourceSetup";
// export const FilingResourceSetupSchema = yup.object().shape({
//   // CONTACT PERSON
//   name: yup
//     .string()
//     .required("Name is required!")
//     .min(3, "Minimum length 3 characters required")
//     .max(50, "Maximum length 50 characters"),

//   effectiveFromYear: yup.string().required("Effective Form Year is required!"),

//   phone1: yup
//     .string()
//     // .matches(
//     //   /^\(\d{3}\) \d{3}-\d{3}$/,
//     //   "Please enter a valid phone number like (777) 777-777."
//     // )
//     .required("Phone is required!")
//     .min(14, "Minimum length 10 characters"),

//   // ISSUER
//   role: yup
//     .array()
//     .of(yup.string())
//     .min(1, "At least one option must be selected"),
//   ownerSin1: yup.string().when("role", (role, schema) => {
//     const roleArray = Array.isArray(role) ? role : [];
//     if (roleArray.includes("6173ddf7-68e2-426f-b1be-9d1dd63eb49d")) {
//       return schema
//         .test("is-masked-or-not", "Invalid value", function (value: any) {
//           if (value) {
//             let sin = value.replace(/-/g, "");
//             const output = checkSINValidity(sin);
//             let maxLength = 11;

//             if (value.charAt(2) === "*") {
//               maxLength = 7;
//             }

//             if (
//               value.length === maxLength &&
//               (value.charAt(2) === "*" || output % 10 === 0)
//             ) {
//               return true;
//             }
//             return this.createError({
//               message: "Invalid Social Insurance Number",
//               path: this.path,
//             });
//           }
//           return this.createError({
//             message: "Social Insurance Number is required",
//             path: this.path,
//           });
//         })
//         .required("Social Insurance Number is required");
//     }
//     return schema;
//   }),

//   ownerSin2: yup.string().when("role", (role: any, schema) => {
//     if (
//       Array.isArray(role) &&
//       role.includes("6173ddf7-68e2-426f-b1be-9d1dd63eb49d")
//     ) {
//       return schema
//         .test("is-masked-or-not", "Invalid value", function (value: any) {
//           if (value) {
//             let sin = value.replace(/-/g, "");
//             const output = checkSINValidity(sin);

//             let maxLength = 11;

//             if (value.charAt(2) === "*") {
//               maxLength = 7;
//               if (value.length === maxLength) {
//                 return true;
//               } else {
//                 return this.createError({
//                   message: "Invalid Social Insurance Number",
//                   path: this.path,
//                 });
//               }
//             } else {
//               if (value.length === maxLength && output % 10 === 0) {
//                 return true;
//               } else {
//                 return this.createError({
//                   message: "Invalid Social Insurance Number",
//                   path: this.path,
//                 });
//               }
//             }
//           }
//           return true;
//         })
//         .nullable();
//     }
//     return schema.nullable();
//   }),

//   // TRANSMITTER
//   craTransmitter: yup.string().when("role", (role: any, schema) => {
//     if (
//       currentTaxYear <= 2023 &&
//       Array.isArray(role) &&
//       role.some((r: string) => r === "6173ddf7-68e2-426f-b1be-9d1dd63eb49e")
//     ) {
//       return schema
//         .required("CRA Transmitter is required!")
//         .min(8, "Minimum 8 characters required");
//     }
//     return schema;
//   }),
//   address: yup.string().when("role", (role: any, schema) => {
//     if (
//       Array.isArray(role) &&
//       role.some((r: string) => r === "6173ddf7-68e2-426f-b1be-9d1dd63eb49e")
//     ) {
//       return schema
//         .required("Address is required!")
//         .min(1, "At least 1 character required")
//         .max(60, "Maximum 60 characters required");
//     }
//     return schema;
//   }),
//   city: yup.string().when("role", (role: any, schema) => {
//     if (
//       Array.isArray(role) &&
//       role.some((r: string) => r === "6173ddf7-68e2-426f-b1be-9d1dd63eb49e")
//     ) {
//       return schema
//         .required("City is required!")
//         .min(1, "At least 1 character required")
//         .max(28, "Maximum 28 characters required");
//     }
//     return schema;
//   }),
//   province: yup
//     .string()
//     .nullable()
//     .when("role", (role: any, schema) => {
//       if (
//         Array.isArray(role) &&
//         role.some((r: string) => r === "6173ddf7-68e2-426f-b1be-9d1dd63eb49e")
//       ) {
//         return schema.required("Province is required!");
//       }
//       return schema;
//     }),
//   // country: yup
//   // .string()
//   // .when("role", {
//   //   is: (val: any) => val[0] === '6173ddf7-68e2-426f-b1be-9d1dd63eb49e' || val[1] === '6173ddf7-68e2-426f-b1be-9d1dd63eb49e' || val[2] === '6173ddf7-68e2-426f-b1be-9d1dd63eb49e',
//   //   then: yup
//   //     .string()
//   //     .required("Country is required!"),
//   // }),
//   postCode: yup.string().when("role", (role: any, schema) => {
//     if (
//       Array.isArray(role) &&
//       role.some((r: string) => r === "6173ddf7-68e2-426f-b1be-9d1dd63eb49e")
//     ) {
//       return schema
//         .required("Post Code is required!")
//         .min(6, "At least 6 characters required")
//         .max(6, "Maximum 6 characters required");
//     }
//     return schema;
//   }),
//   contactName: yup.string().when("role", (role: any, schema) => {
//     if (
//       Array.isArray(role) &&
//       role.some((r: string) => r === "6173ddf7-68e2-426f-b1be-9d1dd63eb49e")
//     ) {
//       return schema
//         .required("Contact Name is required!")
//         .min(1, "At least 1 character required")
//         .max(22, "Maximum 22 characters required");
//     }
//     return schema;
//   }),
//   email: yup.string().when("role", (role: any, schema) => {
//     if (
//       Array.isArray(role) &&
//       role.some((r: string) => r === "6173ddf7-68e2-426f-b1be-9d1dd63eb49e")
//     ) {
//       return schema
//         .email("Please enter a valid email.")
//         .required("Email is required!");
//     }
//     return schema;
//   }),

//   // transmitterAccountNumber: yup.string().nullable()
//   // .when("role", {
//   //   is: (val: any) =>
//   //     currentTaxYear > 2023 &&
//   //     (val[0] === "6173ddf7-68e2-426f-b1be-9d1dd63eb49e" ||
//   //      val[1] === "6173ddf7-68e2-426f-b1be-9d1dd63eb49e" ||
//   //      val[2] === "6173ddf7-68e2-426f-b1be-9d1dd63eb49e"),
//   //   then: yup.string().test(
//   //     'is-valid-or-not',
//   //     'Invalid value',
//   //     function (value:any) {
//   //       let maxLength = 15;
//   //
//   //       const firstNineDigits: string = value && value.substring(0, 9);
//   //
//   //       const output = checkSINValidity(firstNineDigits);

//   //         if (value && value.length == maxLength && output % 10 === 0) {
//   //           return true;
//   //         } else {
//   //           return this.createError({
//   //             message: 'Invalid Account Number',
//   //             path: this.path,
//   //           });
//   //         }
//   //     }
//   //   ).nullable().required('Account Number is required'),
//   //   otherwise: yup.string().nullable()
//   // }),
// });
// // if(currentTaxYear){

// // }

const ROLE_ISSUER = "6173ddf7-68e2-426f-b1be-9d1dd63eb49d";
const ROLE_TRANSMITTER = "6173ddf7-68e2-426f-b1be-9d1dd63eb49e";

export const hasRole = (role: any, roleId: string) =>
  Array.isArray(role) && role.includes(roleId);

export const FilingResourceSetupSchema = yup.object({
  // CONTACT PERSON
  name: yup
    .string()
    .required("Name is required!")
    .min(3, "Minimum length 3 characters required")
    .max(50, "Maximum length 50 characters"),

  effectiveFromYear: yup.string().required("Effective Form Year is required!"),

  phone1: yup
    .string()
    .required("Phone is required!")
    .min(14, "Minimum length 10 characters"),

  // ROLE
  role: yup
    .array()
    .of(yup.string())
    .min(1, "At least one option must be selected"),

  // ISSUER
  ownerSin1: yup
    .string()
    .test(
      "ownerSin1-test",
      "Invalid Social Insurance Number",
      function (value: any) {
        const { role } = this.parent;

        if (!hasRole(role, ROLE_ISSUER)) return true;

        if (!value) {
          return this.createError({
            message: "Social Insurance Number is required",
          });
        }

        const sin = value.replace(/-/g, "");
        const output = checkSINValidity(sin);
        const maxLength = value.charAt(2) === "*" ? 7 : 11;

        if (
          value.length === maxLength &&
          (value.charAt(2) === "*" || output % 10 === 0)
        ) {
          return true;
        }

        return this.createError({
          message: "Invalid Social Insurance Number",
        });
      }
    ),

  ownerSin2: yup
    .string()
    .test(
      "ownerSin2-test",
      "Invalid Social Insurance Number",
      function (value: any) {
        const { role } = this.parent;

        if (!hasRole(role, ROLE_ISSUER)) return true;
        if (!value) return true; // optional

        const sin = value.replace(/-/g, "");
        const output = checkSINValidity(sin);
        const maxLength = value.charAt(2) === "*" ? 7 : 11;

        if (
          value.length === maxLength &&
          (value.charAt(2) === "*" || output % 10 === 0)
        ) {
          return true;
        }

        return this.createError({
          message: "Invalid Social Insurance Number",
        });
      }
    ),

  // TRANSMITTER
  // craTransmitter: yup
  //   .string()
  //   .test(
  //     "craTransmitter-test",
  //     "CRA Transmitter is required!",
  //     function (value) {
  //       const { role } = this.parent;

  //       if (currentTaxYear <= 2023 && hasRole(role, ROLE_TRANSMITTER)) {
  //         console.log('value',value)
  //         if (!value || value.length < 6) {
  //           return this.createError({
  //             message: "CRA Transmitter is required! Minimum 8 characters",
  //           });
  //         }
  //       }

  //       return true;
  //     }
  //   ),

  address: yup
    .string()
    .test("address-test", "Address is required!", function (value) {
      const { role } = this.parent;

      if (hasRole(role, ROLE_TRANSMITTER)) {
        if (!value || value.length < 1 || value.length > 60) {
          return this.createError({
            message: "Address is required! (1–60 characters)",
          });
        }
      }
      return true;
    }),

  city: yup.string().test("city-test", "City is required!", function (value) {
    const { role } = this.parent;

    if (hasRole(role, ROLE_TRANSMITTER)) {
      if (!value || value.length < 1 || value.length > 28) {
        return this.createError({
          message: "City is required! (1–28 characters)",
        });
      }
    }
    return true;
  }),

  province: yup
    .string()
    .nullable()
    .test("province-test", "Province is required!", function (value) {
      const { role } = this.parent;

      if (hasRole(role, ROLE_TRANSMITTER) && !value) {
        return this.createError({
          message: "Province is required!",
        });
      }
      return true;
    }),

  postCode: yup
    .string()
    .test("postCode-test", "Post Code is required!", function (value) {
      const { role } = this.parent;

      if (hasRole(role, ROLE_TRANSMITTER)) {
        if (!value || value.length !== 6) {
          return this.createError({
            message: "Post Code must be exactly 6 characters",
          });
        }
      }
      return true;
    }),

  contactName: yup
    .string()
    .test("contactName-test", "Contact Name is required!", function (value) {
      const { role } = this.parent;

      if (hasRole(role, ROLE_TRANSMITTER)) {
        if (!value || value.length < 1 || value.length > 22) {
          return this.createError({
            message: "Contact Name is required! (1–22 characters)",
          });
        }
      }
      return true;
    }),

  email: yup
    .string()
    .test("email-test", "Email is required!", function (value) {
      const { role } = this.parent;

      if (hasRole(role, ROLE_TRANSMITTER)) {
        if (!value) {
          return this.createError({
            message: "Email is required!",
          });
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          return this.createError({
            message: "Please enter a valid email.",
          });
        }
      }
      return true;
    }).nullable(),
});
